import { AxiosResponse } from 'axios';
import { Config } from '../config';
import { LoginResponse } from '../types/authTypes';
import apiClient from './apiClient';

export const getHomeData = async (params: {
  page: number;
  email?: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.featchHome.replace('{page}', `${params.page}`),
    params
  );
  return response;
};
